module.exports = __webpack_public_path__ + "static/tangled-6_ceramic-mixed-media-private-collection-86575a462527136a84d34f4ca3876f78.jpg";